/****************************************************
 * Module Name:  ManageCustomerProfile.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import { Box, Button, Tooltip } from "@mui/material";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import PersonIcon from "@mui/icons-material/Person";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import Constants from "../../utility/constants";
import EmployeeProxy from "../../utility/proxy/manager/employeeProxy";
import NoPermission from "../common/noPermission";
import CommonSnackbar from "../common/commonSnackBar";
import UserProxy from "../../utility/proxy/manager/userProxy";
import ResetPasswordModal from "./resetPassword";
import EditCustomerDetailsModal from "./editCustomerDetailsModal";

export class ManageCustomerProfile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            users: [],
            showEditCustomerProfileModal: false,

            showUserSettingsModal: false,
            userSettingsUserName: "",
            brokerId: "",
            customerId: "",

            editOperation: false,
            sourceData: {},
            errorSnackbar: false,
            loadingButton: false,
            errorMessage: "",
            snackbarVariant: "",

            showEmployeeLoadSpinner: true,

            showResetPasswordModal: false,
            userId: "",
            username: "",
            local_Permission: Constants.USER_PERMISSION.filter(
                (iPermission) =>
                    iPermission.permissionid === Constants.PERMISSIONS.MASTER_USER
            ),

        };
        this.fetchEmployeeData(false);
    }

    fetchEmployeeData = (bAnimateSpinner) => {
        bAnimateSpinner && this.setState({ showEmployeeLoadSpinner: true });
        EmployeeProxy.GetAllBrokerCustomerForEmployee(
            Constants.loggedInUser.id,
            (responseData) => {
                if (responseData) {
                    this.setState({
                        users: responseData,
                        showEmployeeLoadSpinner: false,
                    })
                } else {
                    this.setState({
                        errorSnackbar: true,
                        showEmployeeLoadSpinner: false,
                    })
                }
            }
        );
    };

    resetPassword = (username, password) => {
        this.setState({ loadingButton: true });
        UserProxy.ResetPassword(username, password, (response) => {
            if (response) {
                this.hideResetPasswordModal();
                this.setState({
                    errorSnackbar: true,
                    errorMessage: "Password reset successful",
                    snackbarVariant: "success",
                    loadingButton: false,
                });
            } else {
                this.setState({
                    errorSnackbar: true,
                    errorMessage: Constants.APiFailErrorMessage,
                    snackbarVariant: "error",
                });
            }
        });
    };

    hideResetPasswordModal = () => {
        this.setState({
            showResetPasswordModal: false,
        });
    };

    columns = [
        {
            field: "id",
            headerName: "ID",
            headerAlign: "center",
            align: "center",
            minWidth: 50,
        },
        {
            field: "username",
            headerAlign: "center",
            align: "center",
            headerName: "USER",
            minWidth: 130,
            flex: 1,
            renderCell: renderCellExpand,
        },
        {
            field: "companyname",
            headerAlign: "center",
            align: "center",
            headerName: "COMPANY NAME",
            minWidth: 200,
            flex: 1,
            renderCell: renderCellExpand,
        },
        {
            field: "first_name",
            headerAlign: "center",
            align: "center",
            headerName: "FIRST NAME",
            minWidth: 130,
            flex: 1,
            renderCell: renderCellExpand,
        },
        {
            field: "middle_name",
            headerAlign: "center",
            align: "center",
            headerName: "MIDDLE NAME",
            minWidth: 130,
            flex: 1,
            renderCell: renderCellExpand,
        },
        {
            field: "last_name",
            headerName: "LAST NAME",
            minWidth: 130,
            flex: 1,
            renderCell: renderCellExpand,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "createdby",
            headerName: "CREATED BY",
            width: 170,
            renderCell: renderCellExpand,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "designation",
            headerName: "DESIGNATION",
            headerAlign: "center",
            align: "center",
            minWidth: 130,
            flex: 1,
            renderCell: renderCellExpand,
        },
        {
            field: "usertype",
            headerAlign: "center",
            align: "center",
            headerName: "TYPE",
            minWidth: 100,
            flex: 1,
            valueGetter: (params) => Constants.USER_TYPE[params.value],
            renderCell: (params) => Constants.USER_TYPE[params.value],
        },
        {
            field: "grade",
            headerName: "GRADE",
            headerAlign: "center",
            align: "center",
            minWidth: 60,
            flex: 0.5,
        },
        {
            field: "employeeid",
            headerName: "EMPLOYEE ID",
            minWidth: 100,
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        {
            field: "location",
            headerName: "LOCATION",
            width: 100,
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        {
            field: "country",
            headerName: "COUNTRY",
            minWidth: 70,
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand,
        },
        {
            field: "deleted",
            headerName: "DELETED",
            headerAlign: "center",
            align: "center",
            minWidth: 90,
            flex: 1,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                return params.value === false ? (
                    <Tooltip title="Active">
                        <Box>
                            <PersonIcon color="success" />
                        </Box>
                    </Tooltip>
                ) : (
                    <Tooltip title="Inactive">

                        <Box>
                            <PersonOffIcon color="error" />
                        </Box>
                    </Tooltip>
                );
            },
        },
        {
            field: "disabled",
            headerName: "DISABLED",
            headerAlign: "center",
            align: "center",
            minWidth: 90,
            flex: 1,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                return params.value === false ? (
                    <Tooltip title="Enable">
                        <Box>
                            <PersonIcon color="success" />
                        </Box>
                    </Tooltip>
                ) : (
                    <Tooltip title="Disable">

                        <Box>
                            <PersonOutlineOutlinedIcon color="error" />
                        </Box>
                    </Tooltip>
                );
            },
        },
        {
            field: "resetpassword",
            headerName: "RESET PASSWORD",
            headerAlign: "center",
            align: "center",
            export: false,
            minWidth: 140,
            flex: 1,
            renderCell: (params) => (
                <Box>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={() =>
                            this.setState({
                                showResetPasswordModal: true,
                                username: params.row.username,
                                userId: params.row.id,
                                loadingButton: false,
                            })
                        }
                    >
                        Reset
                    </Button>
                </Box>
            ),
        },
        {
            field: "edit",
            headerName: "EDIT",
            headerAlign: "center",
            align: "center",
            minWidth: 50,
            flex: 0.5,
            export: false,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                return (
                    <Box
                        style={{ textAlign: "center", cursor: "pointer" }}
                        onClick={() => {
                            this.setState({
                                showEditCustomerProfileModal: true,
                                editOperation: true,
                                sourceData: params.row,
                                loadingButton: false,
                            });
                        }}
                    >
                        <BorderColorIcon color="primary" />
                    </Box>
                );
            },
        },
    ];

    hideEditCustomerProfileManageModal = () => {
        this.setState({
            showEditCustomerProfileModal: false,
        });
    };

    saveUserDetails = (userData) => {
        UserProxy.UpdateUserAndProfileDetails([userData], (response) => {
            if (response) {
                this.hideEditCustomerProfileManageModal();
                this.fetchEmployeeData(false);
                this.setState({
                    errorSnackbar: true,
                    errorMessage: "User edited successfully",
                    snackbarVariant: "success",
                    loadingButton: false,
                });
            } else {
                this.setState({
                    errorSnackbar: true,
                    errorMessage: Constants.APiFailErrorMessage,
                    snackbarVariant: "error",
                    loadingButton: false,
                });
            }
        });
    };

    handleValidation = (userData) => {
        //TODO do validation if needed here
        return true;
    };

    render() {
        if (Constants.loggedInUser.usertype !== 'E') {
            return <NoPermission />
        }

        return (
            <Box>
                <CommonSnackbar
                    show={this.state.errorSnackbar}
                    message={<Box>{this.state.errorMessage}</Box>}
                    variant={this.state.snackbarVariant}
                    autoHide={Constants.SnackBarCloseTimer}
                    handleClose={() => this.setState({ errorSnackbar: false })}
                    title="Failed"
                />
                {this.state.showEditCustomerProfileModal ? (
                    <EditCustomerDetailsModal
                        Show={true}
                        handleClose={this.hideEditCustomerProfileManageModal}
                        handleSave={this.saveUserDetails}
                        handleValidation={this.handleValidation}
                        editOperation={this.state.editOperation}
                        sourceData={this.state.sourceData}
                        loading={this.state.loadingButton}
                        saveButton={true}
                        permission={this.state.local_Permission} //as this will be used by employees to edit their customers profile
                    // if he has permission he camn view all the customers else only attached customers
                    />
                ) : null}

                {this.state.showResetPasswordModal ? (
                    <ResetPasswordModal
                        Show={true}
                        handleClose={this.hideResetPasswordModal}
                        handleSave={this.resetPassword}
                        handleValidation={this.handleValidation}
                        editOperation={this.state.editOperation}
                        userid={this.state.userId}
                        username={this.state.username}
                        loading={this.state.loadingButton}
                    />
                ) : (
                    <Box />
                )}

                <Box px={1}>
                    {/* <Container maxWidth="xxl" sx={{ mt: 1 }}> */}
                    <Box
                        sx={{
                            backgroundColor: '#fff',
                            color: '#000',
                            width: "100%",
                            position: "relative",
                            "& .MuiTablePagination-selectLabel": {
                                marginTop: "15px",
                            },
                            "& .MuiTablePagination-displayedRows": {
                                marginTop: "15px",
                            },
                            "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                fontWeight: Constants.defaultFontWeight,
                            },
                            "& .css-cc8tf1": {
                                fontWeight: Constants.defaultFontWeight,
                            },
                            height: "85vh",
                        }}
                    >
                        <DataGridPro
                            disableRowSelectionOnClick={true}
                            getRowHeight={() => "auto"}
                            slots={{ toolbar: GridToolbar }}
                            rows={this.state.users}
                            density="compact"
                            columns={this.columns}
                            getRowId={(row) => row.id}
                            sx={{
                                '& .MuiDataGrid-columnHeader': {
                                    color: '#fff',
                                    backgroundColor: 'grey',
                                },
                                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                    py: "4px",
                                },
                                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                    py: "12px",
                                },
                                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                    py: "18px",
                                },
                                fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight
                            }}
                            initialState={{
                                columns: {
                                    columnVisibilityModel: {
                                        // Hide columns status and traderName, the other columns will remain visible
                                        locationid: false,
                                        employeeid: false,
                                        designation: false,
                                        usertype: false,
                                        createdby: false,
                                    },
                                },
                                pagination: {
                                    paginationModel: Constants.pageSize,
                                },
                            }}
                            pageSizeOptions={Constants.pageSizeOptions}
                            pagination
                            slotProps={{
                                toolbar: {
                                    showQuickFilter: true,
                                    quickFilterProps: { debounceMs: 500 },
                                },
                            }}
                            loading={this.state.showEmployeeLoadSpinner}
                        />
                        <Box style={{ position: "absolute", top: 5, right: "270px" }}>
                            {this.state.showEmployeeLoadSpinner ? (
                                <CircularProgress size="1rem" />
                            ) : (
                                <Tooltip title="Reload List">
                                    <RefreshOutlinedIcon
                                        color="primary"
                                        fontSize="medium"
                                        onClick={() => this.fetchEmployeeData(true)}
                                        sx={{ cursor: "pointer" }}
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </Box>
                    {/* </Container> */}
                </Box>
            </Box>
        );
    }
}

export default ManageCustomerProfile;
